import React from 'react';
import { TooltipCustom } from 'utils';
import classes from './RecordVideo.module.css';

const RecorderButton = ({ onClick, tooltip, preventHide, withBorder, Icon, isLoading = false }) => {
  return (
    <TooltipCustom title={tooltip} arrow placement="bottom">
      <div
        className={`${classes.recorder_btn_container} ${preventHide ? 'prevent-hide' : ''} `}
        onClick={onClick}
        style={{
          border: withBorder ? '1px solid #EBEDF0' : '',
        }}
      >
        {isLoading ? 'loading..' : <Icon fontSize={'small'} />}
      </div>
    </TooltipCustom>
  );
};

export default RecorderButton;
